import React, { memo } from "react";
import { useSelector } from "react-redux";

import { GeneralInfo } from "./GeneralInfo";
import { Actions } from "./Actions";
import { VehicleWrapperStyled } from "./styles";
import {
  getIsStationVehiclesLoaded,
  getIsMissionsInQueueLoaded,
} from "Slices/stationConfirmation";

export interface VehicleDetail extends StationVehicle {
  link: string | undefined;
  name: string;
  missionPlan: Mission | undefined;
}

interface VehicleProps {
  data: VehicleDetail;
  isLast: boolean;
}

export const Vehicle = memo(({ data, isLast }: VehicleProps) => {
  const {
    id,
    link,
    name,
    queuedMissionId,
    missionPlan,
    cloudConfirmations,
    hmiButtonConfirmed,
    // status,
    version,
    missionName,
  } = data;

  const isStationVehiclesLoaded = useSelector(getIsStationVehiclesLoaded);
  const isMissionsInQueueLoaded = useSelector(getIsMissionsInQueueLoaded);

  // Show loading if either station vehicles or missions in queue are not loaded
  const isLoading = !isStationVehiclesLoaded || !isMissionsInQueueLoaded;

  return (
    <VehicleWrapperStyled isLastOne={isLast}>
      <GeneralInfo
        link={link}
        name={name}
        missionId={queuedMissionId}
        missionPlan={missionPlan}
        isLoading={isLoading}
        missionName={missionName}
      />
      <Actions
        sessionId={id}
        cloudConfirmations={cloudConfirmations}
        hmiButtonConfirmed={hmiButtonConfirmed}
        version={version}
      />
    </VehicleWrapperStyled>
  );
});
